// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner___CtPJ","sk-bouncedelay":"Loader_sk-bouncedelay__L0a2i","bounce1":"Loader_bounce1__3JxzQ","bounce2":"Loader_bounce2__2e7Gq"};